<div class="eidos-date-selector-grid-wrapper">
    <div class="eidos-date-selector-grid" [ngClass]="{ 'cursor-danger': disabled }">

        <dx-data-grid #calendarDataGrid
            class="res-data-grid" height="100%" width="100%" [dataSource]="structuredDataSource"
            [keyExpr]="'month'" [showBorders]="true" [showRowLines]="true" (onCellPrepared)="onCellPrepared($event)"
            (onCellClick)="onCellClick($event)">

            <dxi-column width="auto" fixed="true" fixedPosition="left" cellTemplate="monthTemplate">
            </dxi-column>

            <div *dxTemplate="let data of 'monthTemplate'" style="text-align: center">
                <span class="cell-month">{{ data.data.month }}</span>
            </div>

            <dxi-column *ngFor="let d of days" [dataField]="d" [caption]="d" headerCellTemplate="dayHeaderTemplate" cellTemplate="dayTemplate">
            </dxi-column>
            <div *dxTemplate="let cellInfo of 'dayHeaderTemplate'" style="text-align: center; line-height: 20px" height="100%">
                <span>{{cellInfo.column.caption}}</span>
            </div>

            <div *dxTemplate="let data of 'dayTemplate'" style="text-align: center" height="100%">
                <ng-container [ngTemplateOutlet]="cellDayTemplate"
                    [ngTemplateOutletContext]="{cellData: getCellData(data)}">
                </ng-container>
            </div>

        </dx-data-grid>

    </div>

    <div class="eidos-date-selector-grid-info">
        <div class="eidos-date-selector-grid-info--legend">
            <span class="wk"><i class="fa-solid fa-circle"></i> Weekend</span>
            <span class="na"><i class="fa-solid fa-ban"></i> Not available</span>
            <span *ngIf="checkInDay" class="check-in"><i class="fa-solid fa-circle"></i> Check in day</span>
            <span *ngIf="bookedDays && bookedDays.length > 0" class="booked-day"><i class="fa-solid fa-circle"></i> Booked</span>
            <span *ngIf="hasAnyOverlay && customLegend.length<=0" class="overlay-legend"><span class="bg-icon"></span> Inspect for more details</span>
            <ng-container  *ngFor="let l of legendExt">
              <span class="ms-3 me-3">{{l.char}}
              </span>
              <span>{{l.desc}}</span>
            </ng-container>
            <ng-container *ngFor="let el of customLegend">
              <span *ngIf="hasAnyOverlay" class="overlay-legend"><span [ngClass]="el.class"></span> {{el.label}}</span>
            </ng-container>
        </div>
        <div *ngIf="multiRange">
            Press CTRL to select multiple range of days or SHIFT to select multiple single days.
        </div>
    </div>

</div>

<ng-template #cellDayTemplate let-cellData="cellData">
    <div [ngClass]="cellData.overlay? cellData.overlay?.class : {}" [tooltipDrawer]="cellData.overlay?.component"
        [tooltipData]="cellData.overlay?.data" trigger="hover">
        <div *ngIf="isAvailable(cellData); else notAvailableTemplate" class="cell-day"
            [title]="getWeekDay(cellData)+ (cellData[tooltip] ?? '')"
            [ngClass]="checkCellFlag(cellData, 'selected') ? 'cell-selected' : checkCellFlag(cellData, 'inRange') ? 'cell-in-range': ''"
            [ngStyle]="getStatusColor(cellData)">

            <ng-container [ngSwitch]="getCellMode(cellData)">
                <div *ngSwitchCase="DateSelectorGridCellMode.TopAndBottom" class="cell-top-and-bottom-fields">
                    <div class="cell-top-field">{{ cellData[topField] ?? '' }}</div>
                    <div class="cell-bottom-field">{{ cellData[bottomField] || cellData[bottomField] === 0 ?
                        '('+cellData[bottomField]+')' : '' }}</div>
                </div>

                <div *ngSwitchCase="DateSelectorGridCellMode.Top" class="cell-only-top-field">
                    <div class="cell-top-field">{{ cellData[topField] ?? '' }}</div>
                </div>
            </ng-container>
        </div>
    </div>

</ng-template>

<ng-template #notAvailableTemplate>
    <span class="not-available">
        <i class="fa-solid fa-ban"></i>
    </span>
</ng-template>
